import { AbilityTreeKeySchema } from '../zod/inputTypeSchemas/AbilityTreeKeySchema';
import { BattleTeamSchema } from '../zod/inputTypeSchemas/BattleTeamSchema';
import { CandleAlignmentSchema } from '../zod/inputTypeSchemas/CandleAlignmentSchema';
import { CavernsDirectionSchema } from '../zod/inputTypeSchemas/CavernsDirectionSchema';
import { CavernsSubmodeKeySchema } from '../zod/inputTypeSchemas/CavernsSubmodeKeySchema';
import { GameItemSlotSchema } from '../zod/inputTypeSchemas/GameItemSlotSchema';
import { GameItemTypeSchema } from '../zod/inputTypeSchemas/GameItemTypeSchema';
import { GameModeKeySchema } from '../zod/inputTypeSchemas/GameModeKeySchema';
import { HeroHandleSchema } from '../zod/inputTypeSchemas/HeroHandleSchema';
import { PrimaryAttributeSchema } from '../zod/inputTypeSchemas/PrimaryAttributeSchema';
import { PvPSubmodeKeySchema } from '../zod/inputTypeSchemas/PvPSubmodeKeySchema';

export type { AbilityTreeKeyType } from '../zod/inputTypeSchemas/AbilityTreeKeySchema';
export type { BattleTeamType } from '../zod/inputTypeSchemas/BattleTeamSchema';
export type { CandleAlignmentType } from '../zod/inputTypeSchemas/CandleAlignmentSchema';
export type { CavernsDirectionType } from '../zod/inputTypeSchemas/CavernsDirectionSchema';
export type { CavernsSubmodeKeyType } from '../zod/inputTypeSchemas/CavernsSubmodeKeySchema';
export type { GameItemSlotType } from '../zod/inputTypeSchemas/GameItemSlotSchema';
export type { GameItemTypeType } from '../zod/inputTypeSchemas/GameItemTypeSchema';
export type { GameModeKeyType } from '../zod/inputTypeSchemas/GameModeKeySchema';
export type { HeroHandleType } from '../zod/inputTypeSchemas/HeroHandleSchema';
export type { PrimaryAttributeType } from '../zod/inputTypeSchemas/PrimaryAttributeSchema';
export type { PvPSubmodeKeyType } from '../zod/inputTypeSchemas/PvPSubmodeKeySchema';

export const AbilityTreeKey = AbilityTreeKeySchema.enum;
export const BattleTeam = BattleTeamSchema.enum;
export const CandleAlignment = CandleAlignmentSchema.enum;
export const CavernsDirection = CavernsDirectionSchema.enum;
export const CavernsSubmodeKey = CavernsSubmodeKeySchema.enum;
export const GameItemSlot = GameItemSlotSchema.enum;
export const GameItemType = GameItemTypeSchema.enum;
export const GameModeKey = GameModeKeySchema.enum;
export const HeroHandle = HeroHandleSchema.enum;
export const PrimaryAttribute = PrimaryAttributeSchema.enum;
export const PvPSubmodeKey = PvPSubmodeKeySchema.enum;
